import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	changerButtonsDisabledForgeFields: {
		id: 'issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields',
		defaultMessage: 'Some fields in this project and issue type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
	changerButtonsDisabledForgeFieldsIssueTermRefresh: {
		id: 'issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields-issue-term-refresh',
		defaultMessage: 'Some fields in this project and work type don’t allow resizing or minimizing',
		description:
			'The tooltip when the changer buttons on the GIC are disabled when forge fields or ui modifications are detected',
	},
});
